import { Building2, ArrowRight } from "lucide-react";
import { inr } from "../lib/api";

const GRADS = [
  "from-blue-600 to-blue-900",
  "from-violet-600 to-purple-900",
  "from-amber-500 to-yellow-800",
  "from-cyan-600 to-sky-900",
  "from-slate-600 to-slate-800",
];

export const BookCards = ({ sites, onOpenSite }) => (
  <div className="space-y-3">
    <h2 className="font-display text-base md:text-lg font-semibold">Books</h2>
    {sites.length === 0 && <p className="text-sm text-muted-c" data-testid="overview-empty">No books yet</p>}
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="overview-table">
      {sites.map((s, i) => (
        <button key={s.site_id} onClick={() => onOpenSite(s.site_id)} data-testid={`overview-row-${s.site_id}`}
          className={`text-left rounded-2xl p-5 bg-gradient-to-br ${GRADS[i % GRADS.length]} shadow-lg hover:-translate-y-0.5 transition-transform rise`}>
          <div className="flex items-center justify-between">
            <span className="inline-flex items-center gap-2 font-semibold text-white"><Building2 className="h-4 w-4" />{s.name}</span>
            <ArrowRight className="h-4 w-4 text-white/70" />
          </div>
          <p className="font-mono font-bold text-2xl text-white mt-3">{inr(s.balance)}</p>
          <p className="text-xs text-white/70">Net · {s.branch_count} branches · {s.entry_count} entries</p>
          <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
            <div className="rounded-lg bg-black/20 px-3 py-2"><p className="text-[11px] text-white/70">Deposit</p><p className="font-mono text-emerald-300">{inr(s.total_deposit)}</p></div>
            <div className="rounded-lg bg-black/20 px-3 py-2"><p className="text-[11px] text-white/70">Withdraw</p><p className="font-mono text-red-300">{inr(s.total_withdraw)}</p></div>
          </div>
        </button>
      ))}
    </div>
  </div>
);
